import {
  Component,
  ElementRef,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
  ViewEncapsulation,
  Input,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatTabGroup } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { CropperSettings } from 'ngx-img-cropper';
import { isNullOrUndefined } from 'util';
import { config } from '../../../../../config/config';
import { CreateTourCommand } from '../../../../commands/hub/create.tour.command';
import { ConfirmModalComponent } from '../../../../common/components/confirm.modal/confirm.modal.component';
import {
  ConfirmModalActions,
  ConfirmModalData,
} from '../../../../common/components/confirm.modal/confirm.modal.provider';
import { ImageCropperWithPreviewComponent } from '../../../../common/components/image.cropper/image.cropper.component';
import { routeConfigs } from '../../../../common/constants/route.config';
import { HubVisitorFeatureToggle, HubVisitorToggleDataSource } from '../../../../models/hub/hub.visitor.feature.toggle';
import { AlertifyService } from '../../../../services/alertify.service';
import { PDFSettingsStore, ToggleAndDataSourceStore, ToursStore } from '../../../../stores/hub.calendar.store';
import { PDFSettingCommand } from '../../export.pdf.modal/export.pdf.modal.provider';
import { InfoModalData, ShowInfoModalActions } from '../../show.info.modal/show.info.modal.provider';
import { EditTourTitleModalComponent } from '../edit.tour.title.modal/edit.tour.title.modal.component';
import {
  EditTourTitleModalActions,
  EditTourTitleModalData,
} from '../edit.tour.title.modal/edit.tour.title.modal.provider';
import { ImageSelectorComponent } from '../../../../common/components/image.selector/image.selector.component';
import { ButtonTriggerEvent } from '../../../../common/components';
import { BaseComponent } from '../../../../common/components/base.component';
import { PageSpinnerComponent } from '../../../../common/components/page.spinner/page.spinner.component';
import { RowActionButtonsComponent } from '../../../../common/components/row.action.buttons/row.action.buttons.component';
import { GoogleMapsService } from '../../../../common/services/google.maps.service';
import { ModalService } from '../../../../common/services/modal.service';
import { HubTour } from '../../../../models/hub/hub.tour';
import { CustomizationApiService } from '../../../../services/customization.api.service';
import { HubApiService } from '../../../../services/hub.api.service';
import { ImageService } from '../../../../services/image.service';
import { HubComponent } from '../../hub.component';
import { AttractionListComponent } from '../attractions/attraction.list.component';
import { DirectionPlanComponent } from '../direction.plan/direction.plan.component';
import { ShowInfoModalComponent } from 'components/hub/show.info.modal/show.info.modal.component';
import { localStorageKeys } from '../../../../common/constants/local.storage.keys';
import * as jwt_decode from 'jwt-decode';
import { TokenInfo } from '../../../../models/auth/token.info';
import { isEmptyArray } from '../../../../common/extensions';
import { AccountApiService } from '../../../../services/account.api.service';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'ig-tour-management',
  templateUrl: './tour.component.html',
  styleUrls: ['./tour.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TourComponent extends BaseComponent implements OnInit {
  @Input() public type: 'tour' | 'trip';

  public hubName = '';
  public isShowMobileEdit = false;
  public command = new CreateTourCommand();
  public updateCommand = new CreateTourCommand();
  public createTourForm: FormGroup;
  public editTourForm: FormGroup;
  public selectedImageData: string;
  public editingImageData: string;
  public tours: HubTour[];
  public tour: HubTour;
  public isLoadingTourList = false;
  public isLoadingDetailsStyle = false;
  public isLoadingV3Settings = false;
  public aiSettings: any = null;
  public editMode: boolean[];
  public editingTour: HubTour;
  public editingIndex: number;
  public success = false;
  public isPlanStarted = false;
  public isLoading = false;
  public showExceedTip = false;
  public toggles = new HubVisitorFeatureToggle();
  public imageTemp = null;
  @ViewChild('imageselector') public imageSelector: ImageSelectorComponent;
  @ViewChild('direction') public directionPlan: DirectionPlanComponent;
  @ViewChild('directionmobile') public directionMobilePlan: DirectionPlanComponent;
  @ViewChild('attractionlist') public attractionList: AttractionListComponent;
  @ViewChild('tourmobile') public tourMobileDetail: ElementRef;
  @ViewChild('mobileeditspinner') public mobileEditSpinner: PageSpinnerComponent;
  @ViewChildren(RowActionButtonsComponent)
  public actionButtons: QueryList<RowActionButtonsComponent>;
  @ViewChild('pdftourimage') pdfTourImage: ElementRef;
  @ViewChild('pdftripimage') pdfTripImage: ElementRef;
  @ViewChild('tpHomeImg') tpHomeImg: ElementRef;
  @ViewChild('sidefloat') sideFloat: ElementRef;
  @ViewChild('popup') popup: ElementRef;
  @ViewChild('tab') tab: MatTabGroup;
  @ViewChild('tpHomeImgCropper') tpHomeImgCropper: ImageCropperWithPreviewComponent;
  @ViewChild('tourSidebarImgCropper') tourSidebarImgCropper: ImageCropperWithPreviewComponent;
  @ViewChild('tourImgCropper') tourImgCropper: ImageCropperWithPreviewComponent;
  @ViewChild('tripImgCropper') tripImgCropper: ImageCropperWithPreviewComponent;

  public tpHomeImage = {
    isDefault: true,
    url: '',
  };
  public tourSidebarImage = {
    isDefault: true,
    url: '',
  };
  public detailsStyle: string;
  public previewInterval: any;
  public detailsPreview = config.tripPlanner.detailsPreview;
  public sideFloatView = config.tripPlanner.sideFloatView;
  public popupView = config.tripPlanner.popupView;
  public tpHomeImageData: any;
  public tourSidebarImageData: any;
  public maxCroppedWidth = 800;
  public cropperSettingsForPDF: CropperSettings;
  public cropperSettingsForTourSidebar: CropperSettings;
  public PDFSettings: PDFSettingCommand;
  public tempPDFSettings: PDFSettingCommand;
  public PDFSettingImageCorperData: {
    event: any;
    place: any;
    tour: any;
    trip: any;
  };

  public tpSettings: {
    defaultAISuggestedItineraries: string;
    mobileLandingPage: {
      bannerImage: string;
      eventImage: string;
      placeImage: string;
      itineraryImage: string;
      tripImage: string;
      bannerText1: string;
      bannerText2: string;
    };
    desktopPage: {
      listColumns: number;
      listMargin: number;
    };
  } = {
    defaultAISuggestedItineraries: '',
    mobileLandingPage: {
      bannerImage: '',
      eventImage: '',
      placeImage: '',
      itineraryImage: '',
      tripImage: '',
      bannerText1: '',
      bannerText2: '',
    },
    desktopPage: {
      listColumns: 4,
      listMargin: 0,
    },
  };
  public bannerImgData: string | null = null;
  public eventImgData: string | null = null;
  public placeImgData: string | null = null;
  public itineraryImgData: string | null = null;
  public tripImgData: string | null = null;
  public defaultBannerImage = 'https://iti-images.s3.us-east-1.amazonaws.com/imgs/mobile-banner.jpg';
  public defaultEventImage = 'https://iti-images.s3.us-east-1.amazonaws.com/imgs/mobile-event.jpg';
  public defaultPlaceImage = 'https://iti-images.s3.us-east-1.amazonaws.com/imgs/mobile-place.jpg';
  public defaultItineraryImage = 'https://iti-images.s3.us-east-1.amazonaws.com/imgs/mobile-itinerary.jpg';
  public defaultTripImage = 'https://iti-images.s3.us-east-1.amazonaws.com/imgs/mobile-trip.jpg';

  constructor(
    private hubApiService: HubApiService,
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private accountService: AccountApiService,
    private customizationService: CustomizationApiService,
    private parent: HubComponent,
    private alertify: AlertifyService,
    private imageService: ImageService,
    private pdfSettingsStore: PDFSettingsStore,
    private toursStore: ToursStore,
    private toggleAndDataSourceStore: ToggleAndDataSourceStore,
    private googleMapService: GoogleMapsService,
    private modalService: ModalService
  ) {
    super({ activatedRoute });

    this.tpHomeImageData = {};
    this.tourSidebarImageData = {};
    this.PDFSettings = {
      pdf: {
        headerImage: {
          event: { isDefault: true, url: null },
          place: { isDefault: true, url: null },
          tour: { isDefault: true, url: null },
          trip: { isDefault: true, url: null },
        },
      },
      eventCalendarURL: null,
      placeCalendarURL: null,
      moreToursURL: null,
    };
    this.tempPDFSettings = {
      pdf: {
        headerImage: {
          event: { isDefault: true, url: null },
          place: { isDefault: true, url: null },
          tour: { isDefault: true, url: null },
          trip: { isDefault: true, url: null },
        },
      },
      eventCalendarURL: null,
      placeCalendarURL: null,
      moreToursURL: null,
    };
    this.PDFSettingImageCorperData = {
      event: {},
      place: {},
      tour: {},
      trip: {},
    };
  }

  ngOnDestroy() {
    if (this.previewInterval) {
      clearInterval(this.previewInterval);
    }
  }

  public ngOnInit() {
    let { hubName } = this.allRouteParams;
    this.hubName = hubName;
    this.parent.location = 'Trip Planner';
    //this.detailsPreview = this.imageService.imageSourceUrl(config.tripPlanner.detailsPreview);
    //this.sideFloatView = this.imageService.imageSourceUrl(config.tripPlanner.sideFloatView);
    //this.popupView = this.imageService.imageSourceUrl(config.tripPlanner.popupView);

    this.createTourForm = this.formBuilder.group({
      title: [null, [Validators.required]],
      description: [null, []],
    });
    this.editTourForm = this.formBuilder.group({
      title: [null, [Validators.required]],
      description: [null, []],
      v3DefaultAISuggestedItinerary1: [null, []],
      v3DefaultAISuggestedItinerary2: [null, []],
      v3DefaultAISuggestedItinerary3: [null, []],
      mobileBannerText1: [null, []],
      mobileBannerText2: [null, []],
      mobileBannerImage: [null, []],
      mobileEventImage: [null, []],
      mobilePlaceImage: [null, []],
      mobileItineraryImage: [null, []],
      mobileTripImage: [null, []],
    });

    this.clearImgDataIfInputImageUrl();

    this.getTours();

    this.cropperSettingsForPDF = new CropperSettings();
    this.cropperSettingsForTourSidebar = new CropperSettings();

    this.toggleAndDataSourceStore.toggleAndDataSourceCommand
      .takeUntil(this.isDestroyed)
      .subscribe((toggleCommand: HubVisitorToggleDataSource) => {
        if (toggleCommand && toggleCommand.toggle) {
          this.toggles = toggleCommand.toggle;
        }
      });

    setTimeout(() => {
      const rect = this.tab._elementRef.nativeElement.getBoundingClientRect(); //1228 / 3;
      let width = (rect.width - 18 * 6 - 24) / 3;
      width = width <= 0 ? window.innerWidth * 0.379 : width;
      const height = (width * 60) / 210;
      this.cropperSettingsForPDF = this.imageService.createImageCropperSetting(width, height, true);
      this.cropperSettingsForTourSidebar = this.imageService.createImageCropperSetting(400, 600, true);
      // this.cropperSettingsForTourSidebar = this.imageService.createImageCropperSetting(543, 600, true, 600);

      this.customizationService.getTPHomeAndTourSidebarImage(this.hubName).subscribe((images) => {
        this.tpHomeImage.isDefault =
          isNullOrUndefined(images.tpHomeImage) ||
          isNullOrUndefined(images.tpHomeImage.isDefault) ||
          images.tpHomeImage.isDefault;
        this.tpHomeImage.url = isNullOrUndefined(images.tpHomeImage) ? null : images.tpHomeImage.url;
        this.tourSidebarImage.isDefault =
          isNullOrUndefined(images.tourSidebarImage) ||
          isNullOrUndefined(images.tourSidebarImage.isDefault) ||
          images.tourSidebarImage.isDefault;
        this.tourSidebarImage.url = isNullOrUndefined(images.tourSidebarImage) ? null : images.tourSidebarImage.url;
        if (this.tpHomeImage.url) {
          this.tpHomeImageData.image = this.tpHomeImage.url;
          this.logoImageSet('tpHomeImage');
        }
        if (this.tourSidebarImage.url) {
          this.tourSidebarImageData.image = this.tourSidebarImage.url;
          // this.logoImageSet('tpHomeImage');
        }
        setTimeout(() => {
          this.tpHomeImgCropper && this.tpHomeImgCropper.setImageData(this.cropperSettingsForPDF);
          this.tourSidebarImgCropper && this.tourSidebarImgCropper.setImageData(this.cropperSettingsForTourSidebar);
        });
      });

      this.customizationService.getPDFSettings(this.hubName).subscribe((settings: PDFSettingCommand) => {
        this.PDFSettings.pdf.headerImage.event.isDefault =
          isNullOrUndefined(settings) ||
          isNullOrUndefined(settings.pdf.headerImage.event.isDefault) ||
          settings.pdf.headerImage.event.isDefault;
        this.PDFSettings.pdf.headerImage.event.url = this.PDFSettings.pdf.headerImage.event.isDefault
          ? null
          : settings.pdf.headerImage.event.url;

        this.PDFSettings.pdf.headerImage.place.isDefault =
          isNullOrUndefined(settings) ||
          isNullOrUndefined(settings.pdf.headerImage.place.isDefault) ||
          settings.pdf.headerImage.place.isDefault;
        this.PDFSettings.pdf.headerImage.place.url = this.PDFSettings.pdf.headerImage.place.isDefault
          ? null
          : settings.pdf.headerImage.place.url;

        this.PDFSettings.pdf.headerImage.tour.isDefault =
          isNullOrUndefined(settings) ||
          isNullOrUndefined(settings.pdf.headerImage.tour.isDefault) ||
          settings.pdf.headerImage.tour.isDefault;
        this.PDFSettings.pdf.headerImage.tour.url = this.PDFSettings.pdf.headerImage.tour.isDefault
          ? null
          : settings.pdf.headerImage.tour.url;
        if (this.PDFSettings.pdf.headerImage.tour.url) {
          this.PDFSettingImageCorperData.tour.image = this.PDFSettings.pdf.headerImage.tour.url;
        }

        this.PDFSettings.pdf.headerImage.trip.isDefault =
          isNullOrUndefined(settings) ||
          isNullOrUndefined(settings.pdf.headerImage.trip.isDefault) ||
          settings.pdf.headerImage.trip.isDefault;
        this.PDFSettings.pdf.headerImage.trip.url = this.PDFSettings.pdf.headerImage.trip.isDefault
          ? null
          : settings.pdf.headerImage.trip.url;
        if (this.PDFSettings.pdf.headerImage.trip.url) {
          this.PDFSettingImageCorperData.trip.image = this.PDFSettings.pdf.headerImage.trip.url;
        }
        setTimeout(() => {
          this.tourImgCropper && this.tourImgCropper.setImageData(this.cropperSettingsForPDF);
          this.tripImgCropper && this.tripImgCropper.setImageData(this.cropperSettingsForPDF);
        });
      });

      this.getDetailsStyle();
    }, 2000);
  }

  public clearImgDataIfInputImageUrl() {
    for (const element of ['banner', 'event', 'place', 'itinerary', 'trip']) {
      this.editTourForm
        .get(`mobile${element.upperFirstLetter()}Image`)
        .valueChanges.pipe(takeUntil(this.isDestroyed))
        .subscribe((changes) => {
          if (changes) {
            this[element + 'ImgData'] = null;
          }
        });
    }
  }

  public getAISettings() {
    this.isLoadingTourList = true;
    this.hubApiService.getAISettings(this.hubName).subscribe((data) => {
      if (!data) {
        this.alertify.error(`Something went wrong when getting AI settings`);
        return;
      }

      this.aiSettings = data;

      this.customizationService.getTripPlannerSettings(this.hubName).subscribe((settings) => {
        if (!settings) return;

        this.tpSettings = settings;
        if (isEmptyArray(settings.defaultAISuggestedItineraries)) {
          this.editTourForm
            .get('v3DefaultAISuggestedItinerary1')
            .setValue(`Suggest a one-day itinerary in ${this.aiSettings.travelBuddy.cityName || '(Your city name)'}.`);
          this.editTourForm
            .get('v3DefaultAISuggestedItinerary2')
            .setValue(`Suggest a foodie itinerary in ${this.aiSettings.travelBuddy.cityName || '(Your city name)'}.`);
          this.editTourForm
            .get('v3DefaultAISuggestedItinerary3')
            .setValue(
              `Suggest a kid-friendly itinerary in ${this.aiSettings.travelBuddy.cityName || '(Your city name)'}.`
            );
        } else {
          settings.defaultAISuggestedItineraries.forEach((aiItinerary, index) => {
            this.editTourForm.get(`v3DefaultAISuggestedItinerary${index + 1}`).setValue(aiItinerary.title);
          });
        }
      });
    });
  }

  public getTours() {
    this.isLoadingTourList = true;
    this.editMode = [];
    this.hubApiService.getTours(this.hubName).subscribe((data) => {
      data.forEach((x) => {
        this.editMode.push(false);
      });
      this.tours = data;
      this.isLoadingTourList = false;
      this.toursStore.toursCommand.next(this.tours);
    });
  }

  public deleteTour(index: number, $event?) {
    if ($event) {
      $event.stopPropagation();
    }
    let actions = <ConfirmModalActions>{
      confirm: (event: ButtonTriggerEvent) => {
        this.cancelAllEdit();
        this.hubApiService
          .deleteTour(this.hubName, this.tours[index]._id)
          .finally(event.complete)
          .subscribe(() => {
            this.hubApiService.getTours(this.hubName).subscribe((tours) => {
              this.tours = tours;
              this.toursStore.toursCommand.next(this.tours);
            });
          });
      },
    };

    let data = <ConfirmModalData>{
      confirmModalIcon: 'warning',
      confirmModalTitle: 'Alert',
      confirmModalDescription: `Are you sure you want to delete the tour "${this.tours[index].title}"?`,
      confirmModalConfirmButtonText: 'Delete',
      confirmModalCancelButtonText: 'Cancel',
      isAsync: true,
    };

    this.modalService.show({
      component: ConfirmModalComponent,
      providers: [
        { provide: ConfirmModalActions, useValue: actions },
        { provide: ConfirmModalData, useValue: data },
      ],
    });
  }

  public publishOrDePublishTour(tour: HubTour) {
    if (tour.isActive) {
      this.hubApiService.publishTour(this.hubName, tour._id).subscribe(() => {
        this.tours[this.editingIndex].isActive = tour.isActive;
        this.alertify.success('This itinerary is active');

        if (!window.location.href.includes('localhost')) {
          const authToken = localStorage.getItem(localStorageKeys.authToken);
          let tokenInfo = jwt_decode<TokenInfo>(authToken);
          try {
            let trackName = 'ActiveItinerary - ' + tour.title;
            window['pendo'].track(trackName, {
              accountId: tokenInfo.userName,
              timestamp: Date.now(),
              hubName: this.hubName,
            });
          } catch (error) {
            console.error(error);
          }
        }
      });
    } else {
      this.hubApiService.dePublishTour(this.hubName, tour._id).subscribe(() => {
        this.tours[this.editingIndex].isActive = tour.isActive;
        this.alertify.success('This itinerary is inactive');

        if (!window.location.href.includes('localhost')) {
          const authToken = localStorage.getItem(localStorageKeys.authToken);
          let tokenInfo = jwt_decode<TokenInfo>(authToken);
          try {
            let trackName = 'InactiveItinerary - ' + tour.title;
            window['pendo'].track(trackName, {
              accountId: tokenInfo.userName,
              timestamp: Date.now(),
              hubName: this.hubName,
            });
          } catch (error) {
            console.error(error);
          }
        }
      });
    }
  }

  public async updateImage(image) {
    if (image) {
      this.imageSelector.showSpinner();
      if (this.updateCommand.image) {
        // this.updateCommand.image = await this.imageService.compressImageFile(this.updateCommand.image);

        const imageTemp = await this.imageService.compressImageFileToBase64(
          this.updateCommand.image,
          config.compressImgWidth
        );
        const res = await this.hubApiService.uploadBase64ImageToAWS(imageTemp);
        if (res.success) {
          this.updateCommand.image = null;
          this.updateCommand.imageLink = res.url;
        }
      }
      this.hubApiService.updateTourImage(this.hubName, this.editingTour._id, this.updateCommand).subscribe((data) => {
        if (data && data.imageNotUploaded) {
          this.modalService.showErrorModal('Image upload failed!');
          return;
        }
        this.imageSelector.hideSpinner();
        this.alertify.successfully('Update image');
        this.imageSelector.command.image = null;
      });
    }
  }

  public async onImageChange(file) {
    if (file) {
      this.imageTemp = await this.imageService.compressImageFileToBase64(file, config.compressImgWidth);
    }
  }
  public async onMobileImageChange(file, type) {
    if (!file) return;

    this[`${type}ImgData`] = await this.imageService.compressImageFileToBase64(file, config.compressImgWidth);

    this.tpSettings.mobileLandingPage[`${type}Image`] = '';
  }

  public closeTip() {
    this.showExceedTip = false;
  }

  public async createTour(event: ButtonTriggerEvent) {
    if (this.toggles.tour.limit.limited && this.tours && this.tours.length >= this.toggles.tour.limit.limitation) {
      event.complete();
      this.showExceedTip = true;
      return;
    }

    this.showExceedTip = false;

    this.command.order = this.tours.length;
    // if (this.command.image) {
    //     this.command.image = await this.imageService.compressImageFile(this.command.image);
    // }

    // image uploaded
    if (this.imageTemp) {
      const res = await this.hubApiService.uploadBase64ImageToAWS(this.imageTemp);
      if (res.success) {
        this.command.image = null;
        this.command.imageLink = res.url;
      }
    }
    this.hubApiService
      .createTour(this.hubName, this.command)
      .finally(event.complete)
      .subscribe(() => {
        this.command = new CreateTourCommand();
        this.imageTemp = null;
        this.createTourForm.markAsPristine();
        this.selectedImageData = null;
        this.getTours();
        this.alertify.successfully('Create itinerary');

        if (!window.location.href.includes('localhost')) {
          const authToken = localStorage.getItem(localStorageKeys.authToken);
          let tokenInfo = jwt_decode<TokenInfo>(authToken);
          try {
            let trackName = 'CreateItinerary - ' + this.command.title;
            window['pendo'].track(trackName, {
              accountId: tokenInfo.userName,
              timestamp: Date.now(),
              hubName: this.hubName,
            });
          } catch (error) {
            console.error(error);
          }
        }
      });
  }

  public edit(index: number, $event?) {
    if ($event) {
      $event.stopPropagation();
    }
    if (this.isMobile) {
      this.showMobileEdit();
      this.openTourMobile(index);
      return;
    }

    if (index < this.editMode.length) {
      this.editingIndex = index;
      this.editMode.forEach((x, ind) => {
        if (ind !== index) {
          this.editMode[ind] = false;
        }
      });

      setTimeout(() => {
        this.openTour(index);
      });
    }
  }

  public showLink(index: number, $event) {
    if ($event) {
      $event.stopPropagation();
    }
    if (index < 0 || index > this.tours.length - 1) {
      return;
    }
    let link = `${config.serverDomain}${this.hubName}/${routeConfigs.tripPlanner.tourShare.path.substr(
      0,
      routeConfigs.tripPlanner.tourShare.path.indexOf('/:')
    )}`;
    link += '/' + this.tours[index]._id;
    this.modalService.show({
      component: ShowInfoModalComponent,
      providers: [
        { provide: ShowInfoModalActions, useValue: null },
        { provide: InfoModalData, useValue: new InfoModalData('Itinerary Link', null, [link]) },
      ],
      panelClass: 'width-modal-2',
    });
  }

  public onItemDrop(e, toIndex) {
    if (!e || !e.dragData || isNullOrUndefined(e.dragData.order) || isNullOrUndefined(toIndex)) {
      return;
    }

    let tempOrder = e.dragData.order;
    e.dragData.order = this.tours[toIndex].order;
    this.tours[toIndex].order = tempOrder;
    this.tours.sort((a, b) => a.order - b.order);
    this.isLoading = true;
    this.hubApiService.updateTours(this.hubName, this.tours).subscribe((data) => {
      this.isLoading = false;
      this.alertify.successfully('Change itinerary order');
    });
  }

  public logoImageSet(type: string) {
    setTimeout(() => {
      let width = 0,
        height = 0;
      width = Math.min(this.maxCroppedWidth, this.cropperSettingsForPDF.croppedWidth);
      height = (width * this.cropperSettingsForPDF.croppedHeight) / this.cropperSettingsForPDF.croppedWidth;

      let target = null;
      switch (type) {
        case 'tour':
          target = this.pdfTourImage;
          break;
        case 'trip':
          target = this.pdfTripImage;
          break;
        case 'tpHomeImage':
          target = this.pdfTripImage;
          break;
        default:
          break;
      }

      if (target && target.nativeElement) {
        target.nativeElement.style.width = `${width}px`;
        target.nativeElement.style.height = `${height}px`;
      }
    });
  }

  public setDetailsStyle() {
    this.customizationService.setTPDetailsStyle(this.hubName, this.detailsStyle).subscribe(() => {
      this.alertify.successfully('Change details panel style');
    });
  }

  public tabChanged($event) {
    if (!window.location.href.includes('localhost')) {
      const authToken = localStorage.getItem(localStorageKeys.authToken);
      let tokenInfo = jwt_decode<TokenInfo>(authToken);
      try {
        let eventName =
          (this.type === 'tour' ? 'ContentManagement - ItineraryBuilder - ' : 'ContentManagement -  TripPlanner - ') +
          $event.tab.textLabel;
        let trackName = 'click - ' + eventName + $event.tab.textLabel;
        window['pendo'].track(trackName, {
          accountId: tokenInfo.userName,
          timestamp: Date.now(),
          hubName: this.hubName,
        });
      } catch (error) {
        console.error(error);
      }
    }

    if ($event.index === 3) {
      if (!this.aiSettings) {
        this.getAISettings();
      }
    }
  }

  openNewItineraryBuilder() {
    // const url = "https://devnext.imgoingcalendar.com/Savannah/itineraries/edit";
    const url = window.location.href.includes('localhost')
      ? `https://localhost:4201/${this.hubName}/itineraries/edit`
      : `${config.serverDomainV3}${this.hubName}/itineraries/edit`;
    const windowName = 'PopupWindow';
    const windowFeatures =
      'width=2500,height=1400,toolbar=no,location=no,directories=no,status=no,menubar=no,resizable=yes,scrollbars=yes';

    let popup = window.open(url, windowName, windowFeatures);
    if (popup) {
      /**
       * here we use a simple post message to avoid Itinerary V3 editor requires authentication
       * although this is not a very secure way, for systems like ImGoing, it can be understood as sacrificing a certain level of security in exchange for ease of use
       * send it multiple times to ensure the popup window is opened and can receive the message, can refacor here
       * */
      this.postMessageToItineraryBuilderV3(popup, 2000);
      this.postMessageToItineraryBuilderV3(popup, 4000);
      this.postMessageToItineraryBuilderV3(popup, 7000);

      if (!window.location.href.includes('localhost')) {
        const authToken = localStorage.getItem(localStorageKeys.authToken);
        if (authToken) {
          let tokenInfo = jwt_decode<TokenInfo>(authToken);
          try {
            let trackName = 'ItineraryBuilder - V3 - OpenNewItineraryBuilder';
            window['pendo'].track(trackName, {
              accountId: tokenInfo.userName,
              timestamp: Date.now(),
              hubName: this.hubName,
            });
          } catch (error) {
            console.error(error);
          }
        }
      }
    } else {
      alert('Popup blocked. Please check your browser settings.');
    }
  }

  private postMessageToItineraryBuilderV3(popup: Window, delay: number) {
    setTimeout(() => {
      popup.postMessage({ type: 'origin', data: 'REDIRECT_FROM_DXP' }, '*');
    }, delay);
  }

  private getDetailsStyle() {
    this.isLoadingDetailsStyle = true;
    this.customizationService.getTPDetailsStyle(this.hubName).subscribe((style) => {
      this.isLoadingDetailsStyle = false;
      this.detailsStyle = style;
      this.setPreviewInterval();
    });
  }

  private setPreviewInterval() {
    this.previewInterval = setInterval(() => {
      if (this.detailsStyle === 'float') {
        if (this.sideFloat) {
          this.sideFloat.nativeElement.style.left = '435px';
          this.sideFloat.nativeElement.style.opacity = 1;
          setTimeout(() => {
            if (this.sideFloat) {
              this.sideFloat.nativeElement.style.left = '333px';
              this.sideFloat.nativeElement.style.opacity = 0;
            }
          }, 2000);
        }
      } else if (this.detailsStyle === 'popup') {
        if (this.popup) {
          this.popup.nativeElement.style.top = '30px';
          this.popup.nativeElement.style.opacity = 1;
          setTimeout(() => {
            if (this.popup) {
              this.popup.nativeElement.style.top = '60px';
              this.popup.nativeElement.style.opacity = 0;
            }
          }, 2000);
        }
      }
    }, 3000);
  }

  private openTour(index: number) {
    this.actionButtons.toArray()[index].startLoading();
    this.hubApiService.getTourDetail(this.hubName, this.tours[index]._id).subscribe((data) => {
      this.actionButtons.toArray()[index].stopLoading();
      let items = [];
      data.attractions.forEach((item) => {
        if (item.status !== 'not found') {
          items.push(item);
        }
      });
      data.attractions = items;
      this.editMode[index] = true;
      this.editingTour = data;
      this.editingTour.isEventImageProcessed = true;
      this.editingImageData = this.imageService.imageSourceUrl(this.editingTour.image);
    });
  }

  private openTourMobile(index: number) {
    this.mobileEditSpinner.show();
    this.hubApiService.getTourDetail(this.hubName, this.tours[index]._id).subscribe((data) => {
      let items = [];
      data.attractions.forEach((item) => {
        if (item.status !== 'not found') {
          items.push(item);
        }
      });
      data.attractions = items;
      this.editingTour = data;
      this.editingImageData = this.imageService.imageSourceUrl(this.editingTour.image);
      this.isShowMobileEdit = true;
      setTimeout(() => {
        this.mobileEditSpinner.hide();
      }, 500);
    });
  }

  public cancelEdit(index?: number) {
    if (this.isMobile) {
      this.hideMobileEdit();
    } else {
      if (index < this.editMode.length) {
        this.editMode[index] = false;
      }
    }
  }

  public cancelAllEdit() {
    for (let i = 0; i < this.editMode.length; i++) {
      this.editMode[i] = false;
    }
  }

  public showEditTitlePopup() {
    let actions = <EditTourTitleModalActions>{
      confirm: (event: ButtonTriggerEvent, title, description) => {
        this.tours[this.editingIndex].title = title;
        this.tours[this.editingIndex].description = description;
        this.editingTour.title = title;
        this.editingTour.description = description;
      },
    };

    let data = <EditTourTitleModalData>{
      isAsync: true,
      id: this.editingTour._id,
      title: this.editingTour.title,
      description: this.editingTour.description,
      hubName: this.hubName,
    };

    this.modalService.show({
      component: EditTourTitleModalComponent,
      providers: [
        { provide: EditTourTitleModalActions, useValue: actions },
        { provide: EditTourTitleModalData, useValue: data },
      ],
    });
  }

  public startPlan() {
    this.isPlanStarted = true;
    this.attractionList.detailsPanel.closeDetails();
  }

  public stopPlan() {
    this.isPlanStarted = false;
  }

  public redrawDirectionMap(tour) {
    this.editingTour = tour;
    this.directionPlan.setTour(this.editingTour);
    this.directionPlan.drawFullRoute();
  }

  public async saveTPHomeImage(event: ButtonTriggerEvent) {
    let imageFile = this.imageService.getImageFileByBase64(this.tpHomeImageData.image);
    // let data = {isDefault: this.tpHomeImage.isDefault, url: this.tpHomeImageData.image};
    //this.customizationService.setTPHomeImage(this.hubName, data)
    imageFile = await this.imageService.compressImageFile(imageFile, 780);
    this.customizationService
      .setTPHomeImageFile(this.hubName, {
        isDefault: this.tpHomeImage.isDefault,
        image: imageFile,
      })
      .finally(event.complete)
      .subscribe(() => {
        this.alertify.successfully('Update Trip Planner Home image');
      });
  }

  public async saveTourSidebarImage(event: ButtonTriggerEvent) {
    let url = '';
    if (!this.tourSidebarImage.isDefault) {
      const res = await this.hubApiService.uploadBase64ImageToAWS(this.tourSidebarImageData.image, 1200);
      if (res.success) {
        url = res.url;
      } else {
        this.alertify.error('Upload image failed, please try again.');
        return;
      }
    }

    this.customizationService
      .setTourSidebarImageFile(this.hubName, {
        isDefault: this.tourSidebarImage.isDefault,
        imageUrl: url,
      })
      .finally(event.complete)
      .subscribe(() => {
        this.alertify.successfully('Update itinerary sidebar image');
      });
  }

  public async savePDFTourHeaderImage(event: ButtonTriggerEvent) {
    let data = {
      isDefault: this.PDFSettings.pdf.headerImage.tour.isDefault,
      url: '',
    };

    if (!this.PDFSettings.pdf.headerImage.tour.isDefault) {
      let imageFile = await this.imageService.compressImageFile(
        this.imageService.getImageFileByBase64(this.PDFSettingImageCorperData.tour.image),
        780
      );
      let imageBase64 = await this.imageService.getBase64ByImageFile(imageFile);
      data = {
        isDefault: this.PDFSettings.pdf.headerImage.tour.isDefault,
        url: imageBase64,
      };
    }

    this.customizationService
      .setPDFTourHeaderImage(this.hubName, data)
      .finally(event.complete)
      .subscribe(() => {
        this.alertify.successfully('Update export PDF itinerary image');
      });
  }

  public async savePDFTripHeaderImage(event: ButtonTriggerEvent) {
    // let data = {
    //     isDefault: this.PDFSettings.pdf.headerImage.trip.isDefault,
    //     url: this.PDFSettingImageCorperData.trip.image
    // };
    let imageFile = await this.imageService.compressImageFile(
      this.imageService.getImageFileByBase64(this.PDFSettingImageCorperData.trip.image),
      780
    );
    let imageBase64 = await this.imageService.getBase64ByImageFile(imageFile);
    let data = {
      isDefault: this.PDFSettings.pdf.headerImage.trip.isDefault,
      url: imageBase64,
    };
    this.customizationService
      .setPDFTripHeaderImage(this.hubName, data)
      .finally(event.complete)
      .subscribe(() => {
        this.alertify.successfully('Update export PDF user trip image');
        //this.getPDFSettings();
      });
  }

  public async saveV3Settings(event: ButtonTriggerEvent) {
    let tasks: any[] = [];

    for (const element of ['banner', 'event', 'place', 'itinerary', 'trip']) {
      if (this[element + 'ImgData']) {
        tasks.push(
          this.hubApiService
            .uploadBase64ImageToAWS(this[element + 'ImgData'])
            .then((url) => ({ ...url, type: element }))
        );
      }
    }

    const result = await Promise.all(tasks);
    console.log(result);
    if (result.some((item) => !item.success)) {
      this.alertify.error('Upload image failed, please try again.');
      return;
    }

    const suggestedIti1 = this.editTourForm.get('v3DefaultAISuggestedItinerary1').value;
    const suggestedIti2 = this.editTourForm.get('v3DefaultAISuggestedItinerary2').value;
    const suggestedIti3 = this.editTourForm.get('v3DefaultAISuggestedItinerary3').value;
    const data: { title: string }[] = [];
    if (suggestedIti1) {
      data.push({ title: suggestedIti1 });
    }
    if (suggestedIti2) {
      data.push({ title: suggestedIti2 });
    }
    if (suggestedIti3) {
      data.push({ title: suggestedIti3 });
    }

    // Prepare the settings object
    const tripPlannerSettings = {
      mobileLandingPage: {
        bannerImage: result.find((r) => r.type === 'banner')
          ? result.find((r) => r.type === 'banner').url || this.tpSettings.mobileLandingPage.bannerImage
          : this.tpSettings.mobileLandingPage.bannerImage,
        eventImage: result.find((r) => r.type === 'event')
          ? result.find((r) => r.type === 'event').url || this.tpSettings.mobileLandingPage.eventImage
          : this.tpSettings.mobileLandingPage.eventImage,
        placeImage: result.find((r) => r.type === 'place')
          ? result.find((r) => r.type === 'place').url || this.tpSettings.mobileLandingPage.placeImage
          : this.tpSettings.mobileLandingPage.placeImage,
        itineraryImage: result.find((r) => r.type === 'itinerary')
          ? result.find((r) => r.type === 'itinerary').url || this.tpSettings.mobileLandingPage.itineraryImage
          : this.tpSettings.mobileLandingPage.itineraryImage,
        tripImage: result.find((r) => r.type === 'trip')
          ? result.find((r) => r.type === 'trip').url || this.tpSettings.mobileLandingPage.tripImage
          : this.tpSettings.mobileLandingPage.tripImage,

        bannerText1: this.editTourForm.get('mobileBannerText1').value,
        bannerText2: this.editTourForm.get('mobileBannerText2').value,
      },
      defaultAISuggestedItineraries: data,
      desktopPage: this.tpSettings.desktopPage,
    };

    console.log(tripPlannerSettings);

    this.customizationService
      .setTripPlannerSettings(this.hubName, tripPlannerSettings)
      .finally(event.complete)
      .subscribe(() => {
        this.alertify.successfully('Update Trip Planner settings');

        if (!window.location.href.includes('localhost')) {
          const authToken = localStorage.getItem(localStorageKeys.authToken);
          if (authToken) {
            let tokenInfo = jwt_decode<TokenInfo>(authToken);
            try {
              let trackName = 'TripPlanner - V3 - SaveSettings';
              window['pendo'].track(trackName, {
                accountId: tokenInfo.userName,
                timestamp: Date.now(),
                hubName: this.hubName,
              });
            } catch (error) {
              console.error(error);
            }
          }
        }
      });
  }

  private getPDFSettings() {
    this.customizationService.getPDFSettings(this.hubName).subscribe((settings: PDFSettingCommand) => {
      this.tempPDFSettings.pdf.headerImage.event.isDefault =
        isNullOrUndefined(settings) ||
        isNullOrUndefined(settings.pdf.headerImage.event.isDefault) ||
        settings.pdf.headerImage.event.isDefault;
      this.tempPDFSettings.pdf.headerImage.event.url = this.tempPDFSettings.pdf.headerImage.event.isDefault
        ? null
        : settings.pdf.headerImage.event.url;

      this.tempPDFSettings.pdf.headerImage.place.isDefault =
        isNullOrUndefined(settings) ||
        isNullOrUndefined(settings.pdf.headerImage.place.isDefault) ||
        settings.pdf.headerImage.place.isDefault;
      this.tempPDFSettings.pdf.headerImage.place.url = this.tempPDFSettings.pdf.headerImage.place.isDefault
        ? null
        : settings.pdf.headerImage.place.url;

      this.tempPDFSettings.pdf.headerImage.tour.isDefault =
        isNullOrUndefined(settings) ||
        isNullOrUndefined(settings.pdf.headerImage.tour.isDefault) ||
        settings.pdf.headerImage.tour.isDefault;
      this.tempPDFSettings.pdf.headerImage.tour.url = this.tempPDFSettings.pdf.headerImage.tour.isDefault
        ? null
        : settings.pdf.headerImage.tour.url;

      this.tempPDFSettings.pdf.headerImage.trip.isDefault =
        isNullOrUndefined(settings) ||
        isNullOrUndefined(settings.pdf.headerImage.trip.isDefault) ||
        settings.pdf.headerImage.trip.isDefault;
      this.tempPDFSettings.pdf.headerImage.trip.url = this.tempPDFSettings.pdf.headerImage.trip.isDefault
        ? null
        : settings.pdf.headerImage.trip.url;

      let data = new PDFSettingCommand();
      data.pdf.headerImage = {
        event: {
          isDefault: this.tempPDFSettings.pdf.headerImage.event.isDefault,
          url: this.tempPDFSettings.pdf.headerImage.event.url,
        },
        place: {
          isDefault: this.tempPDFSettings.pdf.headerImage.place.isDefault,
          url: this.tempPDFSettings.pdf.headerImage.place.url,
        },
        tour: {
          isDefault: this.tempPDFSettings.pdf.headerImage.tour.isDefault,
          url: this.tempPDFSettings.pdf.headerImage.tour.url,
        },
        trip: {
          isDefault: this.tempPDFSettings.pdf.headerImage.trip.isDefault,
          url: this.tempPDFSettings.pdf.headerImage.trip.url,
        },
      };
      this.pdfSettingsStore.pdfCommand.next(data);
    });
  }

  private showMobileEdit() {
    this.tourMobileDetail.nativeElement.style.top = '0px';
  }

  private hideMobileEdit() {
    this.tourMobileDetail.nativeElement.style.top = '100%';
    this.isShowMobileEdit = false;
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/tours/tours/tour.component.ts